// The Work-For control as it appears in the surface band. Renders nothing
// without a signed-in user holding canWorkForOthers (rule §D.1).
import { useRefreshProfile } from "@penn/web-common";
import { WorkForSelector } from "@/components/work-for/WorkForSelector";
import { OpenAsCustomerLink } from "./OpenAsCustomerLink";

import { useAppSelector } from "@/stores/hooks";

export function SurfaceWorkFor() {
  const user = useAppSelector((state) => state.auth.user);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const refreshProfile = useRefreshProfile();

  if (!isAuthenticated || !user?.email) return null;
  if (!user.role?.canWorkForOthers) return null;

  return (
    <div className="flex items-center gap-2 min-w-0">
      <WorkForSelector
        variant="bar"
        selfUserId={user.id}
        selfEmail={user.email}
        selfFirstName={user.firstName}
        selfLastName={user.lastName}
        selfCompanyName={user.companyName}
        enabled
        onApplied={() => void refreshProfile()}
      />
      <OpenAsCustomerLink />
    </div>
  );
}
